export default {
  conversation_dnd_message: '{name} está em NP',
  conversation_dnd_message_with_time:
    '{name} está em DND até {time, time, short}',
  conversation_dnd_message_tooltip_content: '{name} não receberá notificações',
};
